const testimonial_swiper = new Swiper(".testimonial-slider-main", {
	direction: "horizontal",
	loop: true,
	simulateTouch: false,
	preloadImages: true,
	autoHeight: true,
	navigation: {
		nextEl: ".testimonial-slider__next",
		prevEl: ".testimonial-slider__prev",
	},
});

const testimonial_swiper_autoplay = new Swiper(".testimonial-slider-main-autoplay", {
	direction: "horizontal",
	loop: true,
	simulateTouch: false,
	preloadImages: true,
	autoHeight: true,
	autoplay: {
		delay: 5000,
	},
	navigation: {
		nextEl: ".testimonial-slider__next",
		prevEl: ".testimonial-slider__prev",
	},
});



